module.exports = __webpack_public_path__ + "asset/img/right.0ca17fd3.png";